import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';
import { IShowConfirmParams } from '@gem/popups';

import Tasks from 'APP/Tasks';

export interface ILeavePageConfirmProps {
  when: boolean;
  text: IShowConfirmParams['text'];
}

export const useLeavePageConfirm = (props: ILeavePageConfirmProps): void => {
  const { t } = useTranslation();

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return currentLocation !== nextLocation && props.when;
  });

  useEffect(() => {
    if (blocker.state === 'blocked') {
      Tasks.app.showConfirm({
        onSuccess: () => {
          blocker.proceed();
        },
        secondaryText: t('cancel'),
        primaryText: t('common_ok'),
        text: props.text,
      });
    }
  }, [blocker]);
};
